import { Grid, TextField, Typography, FormControl, FormHelperText, FormLabel } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updatePersonalInformation } from "../../redux/user/userSlice";
import { API, getCredentialTypeCode, getNirvToken, getScreeningId } from "../../utils/http";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import "react-phone-input-2/lib/material.css";
import { useTranslation } from "react-i18next";
export default function PersonalInformation(props) {
	const { verifier, renderControls, handleNext, handleBack, title, prefilled } = props;
	const dispatch = useDispatch();
	const credentialTypeCode = getCredentialTypeCode();
	const nirvToken = getNirvToken();
	const personalInformation = useSelector((state) => state.user.application.personalInformation);
	const email = useSelector((state) => state.auth.currentAuthenticatedUser?.email);
	const [error, setError] = useState({});
	const { t } = useTranslation();
	const screeningId = getScreeningId();

	// Effect to populate email from auth state into personalInformation if not already set
	useEffect(() => {
		if (email && !personalInformation.email) {
			dispatch(updatePersonalInformation({ email: email }));
		}
	}, [email, personalInformation.email, dispatch]);

	const handlePersonalInfoChange = (e) => {
		let payload = {};
		if (e.target.type == "checkbox") {
			payload = { [e.target.name]: e.target.checked };
		} else {
			payload = { [e.target.name]: e.target.value };
		}
		dispatch(updatePersonalInformation(payload));
	};
	const handleDateOfBirthChange = (newValue) => {
		const birthDate = newValue?.isValid?.() ? newValue.format("YYYY-MM-DD") : "";
		dispatch(updatePersonalInformation({ birthDate }));
	};
	const handlePhoneChange = (phone, country) => {
		const payload = { phoneNumber: phone };
		console.log(country, phone);
		dispatch(updatePersonalInformation(payload));
	};

	const createApplication = () => {
		const nirvToken = getNirvToken();
		const credentialTypeCode = getCredentialTypeCode();
		const screeningId = getScreeningId();
		console.log("Screening Id on Personal Info page: ", screeningId);
		// personalInformation.screeningId

		API.post("application", { personalInformation, credentialTypeCode, screeningId, nirvToken })
			.then((r) => {
				console.log(r);
				dispatch(updatePersonalInformation(r.data.personalInformation));
				toast.success("Application created successfully");
				handleNext();
			})
			.catch((e) => {
				console.log(e);
				toast.error("Application creation failed");
			});
	};
	const handleNextPersonalInformation = () => {
		const errors = verifier(personalInformation);
		console.log(personalInformation);
		console.log(errors);
		if (Object.keys(errors).length === 0) {
			if (prefilled) {
				console.log("update personalInformation with id: ", personalInformation.id);
				console.log("credentialTypeCode: ", credentialTypeCode);
				console.log("nirvToken: ", nirvToken);
				API.put("application", {
					id: personalInformation.id,
					personalInformation,
					credentialTypeCode,
					nirvToken,
				})
					.then((r) => {
						console.log(r);
						toast.success("Application updated successfully");
						handleNext();
					})
					.catch((e) => {
						console.log(e);
						toast.error("Application update failed");
					});
			} else createApplication();
			setError({});
		} else {
			setError(errors);
			toast.error("Please fill in all required fields");
		}
	};
	return (
		<React.Fragment>
			<Typography>{title}</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography>{t("Enter First Name")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="firstName"
						label={t("First Name Label")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.firstName}
						error={!!error.firstName}
						helperText={t(error.firstName)}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						name="middleName"
						label={t("Middle Name Label")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.middleName}
						error={!!error.middleName}
						helperText={t(error.middleName)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography>{t("Enter Last Name")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="lastName"
						label={t("Last Name Label")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.lastName}
						error={!!error.lastName}
						helperText={t(error.lastName)}
					/>
				</Grid>
				<Grid item xs={12}>
					<Typography>{t("Enter Last Name at Birth")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						name="lastNameAtBirth"
						label={t("Last at Birth Label")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.lastNameAtBirth}
						// error={!!error.lastNameAtBirth}
						// helperText={t(error.lastNameAtBirth)}
					/>
				</Grid>
				{/* <Grid item xs={12}>
					<Typography>
						Maiden Name(s) or Alias (Other Names). Maiden Name is the last name/surname a married individual used from birth, prior to it being legally changed
						at marriage. If you have a maiden name, please enter it in this section. If you do not have a maiden name, please do not fill in this field.
					</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						name="maidenName"
						label="Maiden Name"
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.maidenName}
						error={!!error.maidenName}
						helperText={error.maidenName}
					/>
				</Grid> */}
				<Grid item xs={12} sx={{ paddingTop: "0px !important" }}></Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{
							width: { xs: "100%" },
							"& .MuiInputBase-input": {
								backgroundColor: !screeningId ? "#f5f5f5" : "transparent",
								cursor: !screeningId ? "not-allowed" : "text",
							},
						}}
						name="email"
						label={t("Email")}
						variant="outlined"
						value={personalInformation.email || email || ""}
						onChange={handlePersonalInfoChange}
						error={!!error.email}
						// helperText={!screeningId ? "Email field is read-only for regular users" : t(error.email)}
						InputProps={{
							readOnly: true,
						}}
					/>
				</Grid>
				{/* <Grid item xs={12}>
					<TextField
						sx={{ width: { xs: "100%", sm: "inherit" } }}
						name="confirmEmail"
						label="Confirm Email"
						variant="outlined"
						onChange={handleConfirmEmailChange}
						value={confirmEmail}
					/>
				</Grid> */}
				<Grid item xs={12}>
					<FormControl required error={!!error.emailResults}>
						<FormGroup>
							<FormControlLabel
								control={<Checkbox required name="emailResults" onChange={handlePersonalInfoChange} checked={personalInformation.emailResults} />}
								label={t("Agree Email")}
							/>
						</FormGroup>
						<FormHelperText sx={{ display: error.emailResults ? "initial" : "none" }}>{t("Agree Email Error")}</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="birthCity"
						label={t("Place of Birth: City")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.birthCity}
						error={!!error.birthCity}
						helperText={t(error.birthCity)}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="birthCountryCode"
						label={t("Place of Birth: Country")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.birthCountryCode}
						error={!!error.birthCountryCode}
						helperText={t(error.birthCountryCode)}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					{/* <TextField
						required
						sx={{ width: { xs: "100%" } }}
						name="phoneNumber"
						label="Phone"
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.phoneNumber}
						error={!!error.phoneNumber}
						helperText={error.phoneNumber}
					/> */}
					<PhoneInput
						country={"ca"}
						enableSearch={true}
						value={personalInformation.phoneNumber}
						onChange={handlePhoneChange}
						inputClass="phoneInput"
						containerClass="phoneContainer"
						specialLabel={t("Phone Number")}
						inputStyle={{
							paddingTop: "15px",
							paddingBottom: "15px",
							width: "100%",
							background: "transparent",
							borderWidth: 0,
						}}
						placeholder="Phone number"
						helperText={t(error.phoneNumber)}
						isValid={(value, country) => {
							return t(error.phoneNumber);
						}}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					{/* <TextField
						sx={{ width: { xs: "100%", sm: "inherit" } }}
						name="dateOfBirth"
						label="Date of Birth"
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.dateOfBirth}
						error={!!error.dateOfBirth}
						helperText={error.dateOfBirth}
					/> */}
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<DesktopDatePicker
							label={t("Date of Birth")}
							inputFormat="MMM DD YYYY"
							value={personalInformation.birthDate}
							onChange={handleDateOfBirthChange}
							renderInput={(params) => (
								<TextField
									required
									helperText={t(error.birthDate)}
									name="birthDate"
									// onKeyDown={(e) => {
									// 	e.preventDefault();
									// }}
									sx={{ width: { xs: "100%" } }}
									{...params}
									error={!!error.birthDate}
								/>
							)}
							onError={(e) => {
								console.log(personalInformation.birthDate);
								console.log(e);
							}}
							disableFuture
						/>
					</LocalizationProvider>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl sx={{ minWidth: 223, width: { xs: "100%" } }} error={!!error.gender} required>
						<InputLabel>{t("Gender")}</InputLabel>
						<Select name="gender" value={personalInformation.gender} label={t("Gender")} onChange={handlePersonalInfoChange}>
							<MenuItem value="">
								<em>————</em>
							</MenuItem>
							<MenuItem value={"male"}>Male</MenuItem>
							<MenuItem value={"female"}>Female</MenuItem>
							<MenuItem value={"other"}>Other</MenuItem>
						</Select>
						<FormHelperText sx={{ display: error.gender ? "initial" : "none" }}>{t(error.gender)}</FormHelperText>
					</FormControl>
				</Grid>
				<Grid item xs={12}>
					<Typography>{t("Reason and Organization Line")}</Typography>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="purpose"
						label={t("Purpose Label")}
						placeholder="Employment, Volunteer, Rental etc..."
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.purpose}
						error={!!error.purpose}
						inputProps={{
							maxLength: 1024, // Set the character limit here
						}}
						helperText={
							error.purpose
								? `${t(error.purpose)} (Character limit: ${personalInformation.purpose.length}/1024)`
								: `Character limit:  ${personalInformation.purpose.length}/1024`
						}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						sx={{ width: { xs: "100%" } }}
						required
						name="organization"
						label={t("Organization Label")}
						variant="outlined"
						onChange={handlePersonalInfoChange}
						value={personalInformation.organization}
						error={!!error.organization}
						inputProps={{
							maxLength: 128, // Set the character limit here
						}}
						helperText={
							error.organization
								? `${t(error.organization)} (Character limit: ${personalInformation.organization.length}/128)`
								: `Character limit:  ${personalInformation.organization.length}/128`
						}
					/>
				</Grid>
			</Grid>

			{renderControls(handleNextPersonalInformation, handleBack)}
		</React.Fragment>
	);
}
